import React from 'react'
import { useTranslation } from 'i18n'

import PlaceholderImage from 'components/PlaceholderImage'
import './ResultScreen.scss'

const ResultScreen = ({ isGuest, result, socialShare }) => {
  const { t } = useTranslation('textTrivia')
  if (!result) return <div>{t('noResult')}</div>

  const style = {}
  let resultLayout = result?.resultLayout || 'ONE_COLUMN'
  if (result && result?.backgroundColor) {
    style.backgroundColor = result.backgroundColor
  }

  if (result && result?.backgroundImage && result.backgroundImage?.id) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${result.backgroundImage?.id})`
  }

  return (
    <>
      {result && (
        <div>
          <div
            className={`quiz__inner-box quiz__answer${
              result.backgroundImage ? ' bg-image' : ' no-bg-image'
            }${
              isGuest ? ' user-is-guest' : ' user-is-logged-in'
            } orientation-${resultLayout}`}
          >
            <div className="quiz__answer-title">
              <h2
                tabIndex={0}
                aria-label={result.title}
                dangerouslySetInnerHTML={{ __html: result.title }}
              ></h2>
            </div>

            <div className="quiz__answer-copy text-trivia-answer-copy">
              <p
                tabIndex={0}
                aria-label={result.desc}
                dangerouslySetInnerHTML={{ __html: result.desc }}
              ></p>
              {socialShare}
            </div>
            {result?.image?.id && (
              <div className="quiz__answer-image-container">
                <figure className="quiz__answer-image">
                  <PlaceholderImage
                    src={`${process.env.SITE_ASSET_URL}/${result?.image?.id}`}
                    alt=""
                    width={745}
                    height={408}
                  />
                </figure>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
export default ResultScreen
